<div class="modal active">
  <div class="modal__container">
    <div class="fields" *ngIf="features != null">
      <h2>{{ features[0].featureType }}</h2>
      <div class="close" (click)="cancel()"><img src="/assets/img/close-white.svg" alt="" /></div>
      <div class="fields__container">
        <form autocomplete="off"  class="active">
          <div class="fields__block">
            <div class="fields__block__section">
              <app-grit-dynamic-table-features
                [type]="type" [mode]="mode" [features]="features">
              </app-grit-dynamic-table-features>
            </div>
          </div>
          <div class="fields__btn">
            <button class="blue" (click)="ok();">OK</button>
            <button class="gray" (click)="cancel()">Cancel</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
